import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Alert Box Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-alert-box-outline',
    templateUrl: './icon-alert-box-outline.component.html',
    styleUrls: ['./icon-alert-box-outline.component.scss'],
    standalone: false
})
export class IconAlertBoxOutlineComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
